// Framework Modules
import confirm from '@framework/store/modules/confirm'
import errors from '@framework/store/modules/errors'
// Store Modules
import address from './address'
import app from './app'
import auth from './auth'
import cancellations from './cancellations'
// import connectivity from './connectivity'
import contacts from './contacts'
import contracts from './contracts'
import customers from './customers'
import hubspot from './hubspot'
import invoices from './invoices'
import metrics from './metrics'
import number from './number'
import productInventory from './product-inventory'
import reservation from './reservation'
import search from './search'
import sipcentric from './sipcentric'
import bespokes from './bespokes'
import bundles from './bundles'
import scheduledReports from './scheduled-reports'
import sms from './sms'
import sso from './sso'
import staffMembers from './staff-members'
import tariffs from './tariffs'

/**
 *
 * Register modules
 */
export default {
    address,
    app,
    auth,
    cancellations,
    customers,
    contacts,
    contracts,
    // connectivity,
    hubspot,
    invoices,
    metrics,
    number,
    productInventory,
    reservation,
    search,
    sipcentric,
    bespokes,
    bundles,
    scheduledReports,
    sms,
    sso,
    staffMembers,
    tariffs,
    confirm: confirm(),
    errors: errors()
}
